import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { getcomponenteAmbiental, areaEcosistemas, Infomineria } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const ServicioEcosistemaC = ({ municipioId, imganeMineria }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dataEcosistemas, setDataEcosistemas] = useState([]);
    const [dataEcosistemasf, setDataEcosistemasfuente] = useState([]);

    const [municipioNombre, setMunicipioNombre] = useState('');
    const [mineriaData, setDataMineria] = useState([]);

    useEffect(() => {
        if (municipioId) {
                fetchData();
        fetchareaEcosistemas();
        fetcharmineria();    
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getcomponenteAmbiental(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    setMunicipioNombre(response.data[0]?.municipio || 'Desconocido');
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetcharmineria = async () => {
        setLoading(true);
        try {
            const response = await Infomineria(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDataMineria(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading mining data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchareaEcosistemas = async () => {
        setLoading(true);
        try {
            const response = await areaEcosistemas(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setDataEcosistemas(fetchedData);
                    setDataEcosistemasfuente({ datos: fetchedData, fuente: response.data[0]?.fuente || 'Desconocida' });
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading ecosystem data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Definir las columnas para la tabla de ecosistemas
    const ecosystemColumns = [
        {
            title: 'Área de Humedales (hectáreas)', dataIndex: 'humedales_hect', key: 'humedales_hect', className: 'filaP',
        },
        { title: 'Porcentaje de Humedales', dataIndex: 'humedales_porc', key: 'humedales_porc', className: 'filaP', },
        { title: 'Área de Páramos (hectáreas)', dataIndex: 'paramos_hect', key: 'paramos_hect', className: 'filaP', },
        { title: 'Porcentaje de Páramos', dataIndex: 'paramos_porc', key: 'paramos_porc', className: 'filaP', },
        { title: 'Área de Bosque (hectáreas)', dataIndex: 'bosque_hect', key: 'bosque_hect', className: 'filaP', },
        { title: 'Porcentaje de Bosque', dataIndex: 'bosque_porc', key: 'bosque_porc', className: 'filaP', },
        { title: 'Área de Manglar (hectáreas)', dataIndex: 'manglar_hect', key: 'manglar_hect', className: 'filaP', },
        { title: 'Porcentaje de Manglar', dataIndex: 'manglar_porc', key: 'manglar_porc', className: 'filaP', },
        { title: 'Total de Ecosistema (hectáreas)', dataIndex: 'total_ecosistema_hect', key: 'total_ecosistema_hect', className: 'filaP', },
        { title: 'Total de Ecosistema (%)', dataIndex: 'total_ecosistema_porc', key: 'total_ecosistema_porc', className: 'filaP', },
    ];

    // Definir las columnas para la tabla de minería
    const miningColumns = [
        { title: 'Vereda', dataIndex: 'vereda', key: 'vereda', className: 'filaP', },
        { title: 'Tipo de Mineral', dataIndex: 'tipo_mineral', key: 'tipo_mineral', className: 'filaP', },
        { title: 'Mineral', dataIndex: 'mineral', key: 'mineral', className: 'filaP', },
        { title: 'Sistema de Explotación', dataIndex: 'sistema_explotacion', key: 'sistema_explotacion', className: 'filaP', },
        { title: 'Estado de Explotación', dataIndex: 'estado_explotacion', key: 'estado_explotacion', className: 'filaP', },
    ];

    return (
        <div className="page-content">
            {loading ? (
                <Spin size="large" />
            ) : data.length > 0 ? (
                data.map(item => (
                    <div key={item.idinformacion}>
                        <div className="section">
                            <h3>2.3. Minería</h3>
                            <p style={{ columnCount: 2, columnGap: '30px' }}>{item.mineria}</p>
                            <p>{item.fuente_min}</p>
                        </div>
                        <div className="mapaminero  ">
                            <img className="mapa_politicoimg" src={imganeMineria} alt="Mapa minería" />
                        </div>
                    </div>
                ))
            ) : (
                <p>No hay datos disponibles para este municipio.</p>
            )}

            <div className="section">
                <h3>Datos Ecosistemas</h3>
                <Table
                    columns={ecosystemColumns}
                    dataSource={dataEcosistemas}
                    rowKey="oid"
                    pagination={false}
                    footer={() => (
                        <div>
                            <p>{`Fuente: ${dataEcosistemasf.fuente}`}</p>
                        </div>
                    )}
                />
            </div>

            <div className="section">
                <h3>Datos Minería</h3>
                <Table
                    columns={miningColumns}
                    dataSource={mineriaData}
                    rowKey="idmineria"
                    pagination={{ pageSize: 8 }}
                />
            </div>
        </div>
    );
};

export default ServicioEcosistemaC;
